import Vue from 'vue'
import Router from 'vue-router'

import homepage from '@/components/homepage'
import notFound from '@/components/notFound'
import onAir from '@/components/onAir'
import download from '@/components/download'
import activity from '@/components/activity'
import about from '@/components/about'
import hero from '@/components/hero'
import shopping from '@/components/shopping'
import highlights from '@/components/highlights'
import QA from '@/components/QA'
import thanks from '@/components/thanks'
import news from '@/components/news'
import payment from '@/components/payment'

import callback from '@/components/callback'
import tickets from '@/components/tickets'
import ticketType from '@/components/tickets/ticketType'
import ticketInfo from '@/components/tickets/ticketInfo'
import ticketSuccess from '@/components/tickets/ticketSuccess'
import user from '@/components/user'
import booking from '@/components/booking'
import selectArea from '@/components/booking/selectArea'
import selectSeats from '@/components/booking/selectSeats'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: homepage,
      meta: {
        title: '首頁',
        mobileBtn: true
      }
    },
    {
      path: '*',
      name: 'notFound',
      component: notFound,
      meta: {
        title: '404 找不到頁面',
        mobileBtn: true
      }
    },
    {
      path: '/on-air',
      name: 'onAir',
      component: onAir,
      meta: {
        title: '直播 On Air',
        mobileBtn: true
      }
    },
    {
      path: '/download',
      name: 'download',
      component: download,
      meta: {
        title: '可用視覺下載',
        mobileBtn: true
      }
    },
    {
      path: '/activity',
      name: 'activity',
      component: activity,
      meta: {
        title: '活動資訊',
        mobileBtn: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: 'BYOC 相關',
        mobileBtn: true
      }
    },
    {
      path: '/hero',
      name: 'hero',
      component: hero,
      meta: {
        title: 'BYOC 英雄榜',
        mobileBtn: true
      }
    },
    {
      path: '/shopping',
      name: 'shopping',
      component: shopping,
      meta: {
        title: '官方購物',
        mobileBtn: true
      }
    },
    {
      path: '/highlights',
      name: 'highlights',
      component: highlights,
      meta: {
        title: 'WirForce 精彩節目',
        mobileBtn: true
      }
    },
    {
      path: '/QA',
      name: 'QA',
      component: QA,
      meta: {
        title: '相關QA',
        mobileBtn: true
      }
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: thanks,
      meta: {
        title: '特別感謝',
        mobileBtn: true
      }
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        title: '媒體報導',
        mobileBtn: true
      }
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment,
      meta: {
        title: '全家 FamiPort 代碼繳費說明',
        mobileBtn: true
      }
    },
    {
      path: '/callback',
      name: 'callback',
      component: callback,
      meta: {
        title: 'CallBack',
        noLayout: true
      }
    },
    {
      path: '/tickets',
      name: 'tickets',
      component: tickets,
      redirect: {name: 'ticketType'},
      meta: {
        title: '購票系統',
        requiredAuth: true
      },
      children: [
        {
          path: 'ticketType',
          name: 'ticketType',
          component: ticketType,
          meta: {
            title: '選擇票種 | 購票系統',
            requiredAuth: true
          }
        },
        {
          path: 'ticketInfo',
          name: 'ticketInfo',
          component: ticketInfo,
          meta: {
            title: '輸入購票資訊 | 購票系統',
            requiredAuth: true
          }
        },
        {
          path: 'ticketSuccess',
          name: 'ticketSuccess',
          component: ticketSuccess,
          meta: {
            title: '購票完成 | 購票系統',
            requiredAuth: true
          }
        }
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      meta: {
        title: '使用者資訊',
        requiredAuth: true,
        mobileBtn: true
      }
    },
    {
      path: '/booking',
      name: 'booking',
      component: booking,
      redirect: {name: 'selectArea'},
      meta: {
        title: '劃位系統'
        // requiredAuth: true
      },
      children: [
        {
          path: 'selectArea',
          name: 'selectArea',
          component: selectArea,
          meta: {
            title: '選擇區域 | 購票系統'
            // requiredAuth: true
          }
        },
        {
          path: 'selectSeats',
          name: 'selectSeats',
          component: selectSeats,
          meta: {
            title: '選擇座位 | 購票系統'
            // requiredAuth: true
          }
        }
      ]
    }
  ],
  scrollBehavior: function (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js